import React, { useEffect, useRef, useState } from "react";
import TableLayout from "../../components/layouts/table-layout";
import TableHeading from "../../components/common/TableHeading";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptAEStoJSON, EllipsisWithTooltip, toastEmitter } from "../../utils/utilities";
import { doctorListforAvailability } from "../../hooks/services/api-services";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import { DOCTOR_DETAIL_IAMGE, PROFILE_IMG } from "../../utils/aap-image-constant";
import Modal from "../../components/common/Model";
import Input from "../../components/common/input";
import { API_URL } from "../../utils/url-constants";

const BankDetailes = () => {
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const isFirstRender = useRef(true);
  const allowedCountries = ["Saudi Arabia", "United Arab Emirates", "Germany"];

  const ViewMatchingmodal = useRef(null)
  const { t ,i18n} = useTranslation()
  const [searchTerm, setSearchTerm] = useState("");
  const [pending, setPending] = useState(false);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [page, setPage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [viewData, setViewData] = useState({});
  const addButtonClickModal = (data) => {
    setViewData(data);
    ViewMatchingmodal?.current?.click();
  };
  const payload = {
    pageIndex: searchTerm === "" ? page || 0 : 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    status: null,
    country: userData?.country,
    clinicId: userData?.id,
    searchText: searchTerm,
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    bothDoctors: false,
    languageType:i18n.language
  }
  const fetchDoctorBankDetails = async () => {
    setPending(true);
    try {
      const response = await doctorListforAvailability(payload);

      if (response?.data?.status !== 200) {
        if (isFirstRender.current) {
        }
        setRowData([]);
        setTotalRows(0);
      } else {
        const formattedData = response?.data?.data?.doctorResponseList?.map((doctor, index) => {
          const bankDetails = doctor?.bankDetailsResponse || {};

          return {
            id: index + 1 + page * pageSize,
            doctor_name: `${doctor?.firstName || ""} ${doctor?.lastName || ""}`,
            bank_name: bankDetails?.bankName || "N/A",
            account_number: bankDetails?.accountNumber || "N/A",
            account_type: bankDetails?.accountType || "N/A",
            branch_name: bankDetails?.branchName || "N/A",
            national_id: bankDetails?.nationalId || "N/A",
            bankCode: bankDetails?.bankCode || "N/A",
            sirenNo: bankDetails?.sirenNo || "N/A",
            image: doctor?.image
          };
        });
        setRowData(formattedData);
        setTotalRows(response?.data?.data?.totalElement || 0);
      }
    } catch (err) {
      if (isFirstRender.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      }
    } finally {
      setPending(false);
      isFirstRender.current = false;
    }
  };
  useEffect(() => {
    fetchDoctorBankDetails();
  }, [page, pageSize, searchTerm, sortColumn, sortDirection,i18n.language]);
  const tableColumns = [
    {
      code: "id",
      name: t("S.No"),
      width: "80px",
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },
    {
      name: t("Doctor Name"),
      width: "200px",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fs-12 fw-600">
          <div
            className="rounded-circle overflow-hidden rounded-circle"
          >
            <img
              src={row?.image ? `${API_URL?.ServerURL}${row?.image}` : PROFILE_IMG}
              alt="profile"
              style={{
                objectFit: "cover", objectPosition: "center", width: "32px",
                height: "32px",
              }}

            />
          </div>

          {`${row?.doctor_name}`}
        </div>

      ),
      sortable: true,
      code: "first_name",
    },
    {
      code: "bank_name",
      width: "180px",
      name: t("Bank Name"),
      selector: (row) => (
        <EllipsisWithTooltip text={`${row?.bank_name}`} maxWidth="150px" />
      )

    },
     {
      code: "email",
      width: "180px",
      name: t("PayPal Email"),
      selector: (row) => (
        <EllipsisWithTooltip text={`${row?.email}`} maxWidth="150px" />
      )

    },
    {
      code: "account_name",
      width: "180px",
      name: t("Account No."),
      selector: (row) =>
      (
        <EllipsisWithTooltip text={`${row?.account_number}`} maxWidth="150px" />

      )
    },
    {
      code: "branch_name",
      width: "180px",
      name: t("Branch Name"),
      selector: (row) =>
      (
        <EllipsisWithTooltip text={`${row?.branch_name}`} maxWidth="120px" />

      )
    },
    {
      code: "sirenNo",
      width: "180px",
      name: t("SIRENnumber"),
      selector: (row) => row?.sirenNo,
    },
    {
      code: "bankCode",
      name: t("bankcode"),
      width: "160px",

      selector: (row) => row?.bankCode,
    },
    ...(userData && allowedCountries.includes(userData.country)
      ? [
        {
          code: "national_id",
          name: "National ID",
          selector: (row) => row?.national_id,
        },
      ]
      : []),
    {
      name: t("Detail"),
      selector: (row) => row?.detail,
      cell: (row) => (
        <div className="">
          <button className="border-0 bg-white">
            <button
              className="border-0 bg-white"
              onClick={() => addButtonClickModal(row)}
            >
              <img
                src={DOCTOR_DETAIL_IAMGE}
                alt="View"
                className="editicon ms-2"
              />
            </button>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <TableHeading
        className="mt-lg-3 mt-0"
        title={t("Doctor’s Bank Information")}
        showsearchinput={true}
        searchValue={searchTerm}
        setSearchValue={setSearchTerm}
        data="Doctor"
        showbutton={false}
      />
      <div className="table-wrapper">
        <TableLayout
          _tblColumns={tableColumns}
          _rowData={rowData}
          pending={pending}
          pagination={true}
          selectableRows={false}
          setPending={setPending}
          _totalRows={totalRows}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setPage={setPage}
          setSortColumn={setSortColumn}
          setSortDirection={setSortDirection}
        />
      </div>


      <Modal
        modalId="doctorbankdetails"
        closebtnclass="closebtnclass"
        modalClick={ViewMatchingmodal}
        className="modal-lg"
        modalContentClass="add_doctor card px-3 py-0 border border-radius_input"
      >
        <div className="">
          <div className="row text-start">
            <div className="col-md-6 mb-2">
              <Input
                type="text"
                value={viewData?.doctor_name || ""}
                name="doctor_name"
                labelName="Doctor Name"
                disabled={true}
                showAsterisk={false}
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                type="text"
                value={viewData?.bank_name || ""}
                name="bank_name"
                labelName="Bank Name"
                disabled={true}
                showAsterisk={false}
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                type="text"
                value={viewData?.account_number || ""}
                name="account_number"
                labelName="Account Number"
                disabled={true}
                showAsterisk={false}
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                type="text"
                value={viewData?.branch_name || ""}
                name="branch_name"
                labelName="Branch Name"
                disabled={true}
                showAsterisk={false}
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                type="text"
                value={viewData?.bankCode || ""}
                name="Bank Code"
                labelName={t("bankcode")}
                disabled={true}
                showAsterisk={false}
              />
            </div>
            <div className="col-md-6 mb-2">
              <Input
                type="text"
                value={viewData?.sirenNo || ""}
                name="Siren No"
                labelName="Siren No"
                disabled={true}
                showAsterisk={false}
              />
            </div>
            {userData && allowedCountries.includes(userData.country) && (
              <div className="col-12 ">
                <Input
                  type="text"
                  value={viewData?.national_id || ""}
                  name="national_id"
                  disabled={true}
                  showAsterisk={false}
                  labelName="Commercial Registration (CR) number / National ID or Iqama number / Emirates"
                />
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BankDetailes;
